import type { ProductResponse } from "../../admin/products/productsApi";
import type { CalculationProduct } from "../calculationTypes";
import type { Currency } from "../../data/BaseEntity";

const DOUBLE_TWIN_OPTION_NAMES = ["TWIN", "DOUBLE"] as const;

export function getDoubleOrTwinOption(product: Pick<ProductResponse, "options">): { id: string; name: string } | null {
  for (const name of DOUBLE_TWIN_OPTION_NAMES) {
    const option = product.options.find((o) => o.name === name);
    if (option) {
      return { id: option.id, name: option.name };
    }
  }
  return null;
}

function equalsNotNil<T>(v1: T | null | undefined, v2: T | null | undefined): boolean {
  return v1 !== null && v1 !== undefined && v1 === v2;
}

export function getAlternativeProducts(
  calculationProduct: CalculationProduct,
  products: Pick<ProductResponse, "id" | "options" | "productsGroup" | "currency">[],
  calculationCurrency: Currency,
): CalculationProduct[] {
  const product = products.find((p) => p.id === calculationProduct.id);
  if (!product?.productsGroup) {
    return [];
  }
  return products
    .filter((p) => p.id !== product.id)
    .filter(
      (p) => equalsNotNil(p.productsGroup, product.productsGroup) && equalsNotNil(p.currency, calculationCurrency),
    )
    .map((p) => {
      const doubleTwin = getDoubleOrTwinOption(p);
      if (!doubleTwin) {
        return null;
      }
      return {
        id: p.id,
        date: calculationProduct.date,
        options: [{ id: doubleTwin.id, quantity: 1 }],
      };
    })
    .filter((p): p is CalculationProduct => p !== null);
}
